let baseHost = window.location.origin;
if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
  baseHost = "";
} else {
  baseHost = baseHost;
}

const caregiverService = `${baseHost}/homecare/appadmin/caregiver`;
const checkListService = `${baseHost}/homecare/appadmin/device/checklist`;
const vitalService = `${baseHost}/homecare/appadmin/vitals`;
const statusService = `${baseHost}/homecare/appadmin/status`;
const clientService = `${baseHost}/homecare/appadmin/client`;
const communityService = `${baseHost}/homecare/api/v2/communities`;
const extraTaskService = `${baseHost}/homecare/appadmin/extra`;
const versionService = `${baseHost}/homecare/device/app`;
const caregiverLoginService = `${baseHost}/homecare`;
const handoffNotesService = `${baseHost}/homecare/appadmin/handoffnotes`;
const familyportalService = `${baseHost}/homecare/appadmin/familyportal`;
const familymemberService = `${baseHost}/homecare/appadmin/familymember`;
const authService = `${baseHost}/homecare/appadmin/auth`;

export default {
  authLogin: authService + "/login.do",
  authSetPassword: authService + "/completeForgetPassword.do",
  authResetPassword: authService + "/resetPassword.do",
  authGetProfileDetails: authService + "/getProfileDetails.do",
  authGetVerificationStatus: authService + "/getVerificationStatus.do",
  caregiverMobileLogin: caregiverLoginService + "/api/v2/device/caregiver/caregiverLogin",
  forgotPasswordSendOtp: caregiverLoginService + "/api/v2/device/caregiver/forgotPassword",
  verifyForgotPasswordOtp: caregiverLoginService + "/api/v2/device/caregiver/verifyForgotPasswordOtp",
  resetForgotPassword: caregiverLoginService + "/api/v2/device/caregiver/resetPassword",
  familyportalSendEmailOtp: familyportalService + "/sendEmailOTP.do",
  familyportalValidateEmail: familyportalService + "/validateEmail.do",
  familyportalValidateEmailOtp: familyportalService + "/validateEmailOTP.do",
  familyportalSendMobileOtp: familyportalService + "/sendMobileOTP.do",
  familyportalValidateMobileOtp: familyportalService + "/validateMobileOTP.do",
  getClientByFamilyMember: familyportalService + "/getClientByFamilyMember.do",
  getVitalsOfFamilyMember: familyportalService + "/getVitalsOfFamilyMember.do",
  getCheckListOfFamilyMember: familyportalService + "/getCheckListOfFamilyMember.do",
  familymemberValidateSetupToken: familymemberService + "/validateSetupToken.do",
  familymemberSetPassword: familymemberService + "/setPassword.do",
  caregiverLogin: caregiverService + "/caregiverLogin.do",
  caregiverCheckin: caregiverService + "/caregiverCheckin.do",
  caregiverCheckout: caregiverService + "/caregiverCheckout.do",
  getAllUnackChecklistOfCaregiver: checkListService + "/getAllUnackChecklistOfCaregiver.do",
  getAllAckChecklistOfCaregiver: checkListService + "/getAllAckChecklistOfCaregiver.do",
  upateResponseOfCaregiverChecklist: checkListService + "/upateResponseOfCaregiverChecklist.do",
  getAllUnackChecklistOfClient: checkListService + "/getAllUnackChecklistOfClient.do",
  getAllAckChecklistOfClient: checkListService + "/getAllAckChecklistOfClient.do",
  upateResponseOfClientChecklist: checkListService + "/upateResponseOfClientChecklist.do",
  getAssociatedClientsByCaregiverId: caregiverService + "/getAssociatedClientsByCaregiverId.do",
  getAllVitalInfoByClientId: vitalService + "/getAllVitalInfoByClientId.do",
  addVitalInfoByCaregiver: vitalService + "/addVitalInfoByCaregiver.do",
  getStatusConfigList: statusService + "/list.do",
  getCommunityListForCaregiver: communityService + "/getAssociatedCommunity",
  getResidentNotes: clientService + "/getClientNote.do",
  getAllNotesForCaregiver: handoffNotesService + "/getAllNotesForCaregiver.do",
  getNotesAddedByOtherCaregiversForClient: handoffNotesService + "/getNotesAddedByOtherCaregiversForClient.do",
  acknowledgeNote: handoffNotesService + "/acknowledgeNote.do",
  addNote: handoffNotesService + "/addNote.do",
  getNotesAddedByCaregiver: handoffNotesService + "/getNotesAddedByCaregiver.do",
  getUnAckAdditionalTasks: extraTaskService + "/getUnAckAdditionalTasks.do",
  getAckAdditionalTasks: extraTaskService + "/getAckAdditionalTasks.do",
  saveAdditionalTasks: extraTaskService + "/saveAdditionalTasks.do",
  updateAdditionalTaskStatus: extraTaskService + "/updateAdditionalTaskStatus.do",
  getAppVersion: versionService + "/version.do",
  caregiverLogout: caregiverLoginService + "/api/v2/device/caregiver/logout",
  deviceInfo: caregiverLoginService + "/api/v2/device/caregiver/logDeviceInfo",
  refreshAccessToken: caregiverLoginService + "/api/v2/device/caregiver/auth/refreshToken",
};
